/**
 * Returns `undefined`
 *
 * @example
 * ```ts
 * noop() // undefined
 * ```
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop(): void {}

export default noop;
